var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 -2 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7C8.34526 7 7 8.34514 7 9.99995C7 11.6548 8.34524 13 10 13C10.5864 13 11.1339 12.8311 11.5965 12.5393L12.5286 13.4714C12.7889 13.7318 13.2111 13.7318 13.4714 13.4714C13.7318 13.2111 13.7318 12.7889 13.4714 12.5286L12.5393 11.5965C12.8311 11.1339 13 10.5864 13 9.99995C13 8.34514 11.6547 7 10 7ZM8.33333 9.99995C8.33333 9.08157 9.0816 8.33333 10 8.33333C10.9184 8.33333 11.6667 9.08157 11.6667 9.99995C11.6667 10.9184 10.9184 11.6667 10 11.6667C9.08161 11.6667 8.33333 10.9184 8.33333 9.99995Z",
    fill: "#C8A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8612 0.681678C7.09761 0.631247 7.34281 0.712747 7.50199 0.894673L9.48347 3.15921L12.681 1.41508C13.0043 1.23877 13.4092 1.35788 13.5855 1.68111C13.7618 2.00434 13.6427 2.4093 13.3195 2.58561L9.65284 4.58561C9.37871 4.73513 9.03752 4.67435 8.83189 4.43935L7.28586 2.67245L4.9708 10.1964C4.88399 10.4785 4.62202 10.67 4.32688 10.667C4.03173 10.664 3.77368 10.4673 3.69259 10.1835L2.12733 4.70505L1.57911 5.66444C1.39643 5.98411 0.989196 6.09518 0.669518 5.91251C0.349839 5.72983 0.238775 5.3226 0.421448 5.00292L1.75478 2.66958C1.88784 2.43674 2.14746 2.30629 2.4137 2.3385C2.67994 2.37072 2.90095 2.55933 2.97463 2.8172L4.35728 7.65649L6.36309 1.13762C6.43418 0.906571 6.62478 0.73211 6.8612 0.681678Z",
    fill: "#C8A1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInActive);
export default __webpack_public_path__ + "static/media/moreInActive.b4fb032ea143b7ffc890fe47e6306c4d.svg";
export { ForwardRef as ReactComponent };